var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable no-param-reassign */
import React from 'react';
import styles from 'core-components/src/components/button/button.scss';
import cn from 'classnames';
export const Button = (props) => {
    const { children, kind, small, big, outline, inverse, ghost, fluid, className, asLink, target } = props, nativeProps = __rest(props, ["children", "kind", "small", "big", "outline", "inverse", "ghost", "fluid", "className", "asLink", "target"]);
    const classes = cn({
        [styles.button]: true,
        [styles[kind]]: kind,
        [styles.big]: big,
        [styles.fluid]: fluid,
        [styles.ghost]: ghost,
        [styles.inverse]: inverse,
        [styles.outline]: outline,
        [styles.small]: small,
        [className]: className
    });
    return asLink ? (React.createElement("a", Object.assign({ href: target }, nativeProps, { className: classes }), children)) : (
    // eslint-disable-next-line react/button-has-type
    React.createElement("button", Object.assign({}, nativeProps, { className: classes }), children));
};
Button.defaultProps = {
    asLink: false,
    big: false,
    fluid: false,
    ghost: false,
    inverse: false,
    kind: 'primary',
    outline: false,
    small: false,
    target: '',
    type: 'button'
};
